import { render, staticRenderFns } from "./coupon_data.vue?vue&type=template&id=090493b6&"
import script from "./coupon_data.vue?vue&type=script&lang=js&"
export * from "./coupon_data.vue?vue&type=script&lang=js&"
import style0 from "./coupon_data.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports